export function convert_error_to_object(error) {
  if (!error) {
    return {
      type: "unknown",
      message: "Unknown error occurred",
      timestamp: new Date().toISOString(),
    };
  }

  if (typeof error !== "object") {
    return {
      type: "primitive",
      value: error,
      original_type: typeof error,
      message: String(error),
      timestamp: new Date().toISOString(),
    };
  }

  const error_obj = {
    message: "Error occurred",
    timestamp: new Date().toISOString(),
  };

  try {
    if (error instanceof Error) {
      error_obj.type = "Error";
      error_obj.name = error.name || "Error";
      error_obj.message = error.message || "No message provided";
      error_obj.stack = error.stack || "No stack trace available";

      if (error instanceof TypeError) error_obj.type = "TypeError";
      else if (error instanceof ReferenceError)
        error_obj.type = "ReferenceError";
      else if (error instanceof RangeError) error_obj.type = "RangeError";
      else if (error instanceof SyntaxError) error_obj.type = "SyntaxError";
      else if (error instanceof URIError) error_obj.type = "URIError";
      else if (error instanceof EvalError) error_obj.type = "EvalError";

      const additional_props = {};
      for (const key in error) {
        if (key !== "name" && key !== "message" && key !== "stack") {
          try {
            const value = error[key];
            if (value !== undefined && typeof value !== "function") {
              additional_props[key] =
                typeof value === "object"
                  ? JSON.parse(JSON.stringify(value))
                  : value;
            }
          } catch (e) {
            additional_props[key] = "[Circular or non-serializable]";
          }
        }
      }
      if (Object.keys(additional_props).length > 0) {
        error_obj.additional_properties = additional_props;
      }
    } else if (error.constructor && error.constructor.name === "Response") {
      error_obj.type = "HTTPResponse";
      error_obj.status = error.status;
      error_obj.status_text = error.statusText;
      error_obj.url = error.url;
      error_obj.message = `HTTP ${error.status}: ${error.statusText}`;
    } else if (error.constructor && error.constructor.name === "DOMException") {
      error_obj.type = "DOMException";
      error_obj.name = error.name;
      error_obj.message = error.message || "DOM exception occurred";
      error_obj.code = error.code;
    } else {
      error_obj.type = "Object";
      error_obj.constructor = error.constructor
        ? error.constructor.name
        : "Unknown";

      if (error.message) error_obj.message = error.message;
      else if (error.error) error_obj.message = String(error.error);
      else if (error.description) error_obj.message = error.description;
      else error_obj.message = "Object error occurred";

      try {
        const serialized = JSON.parse(JSON.stringify(error));
        error_obj.data = serialized;
      } catch (circular_error) {
        const seen = new WeakSet();
        const clean_object = {};

        for (const key in error) {
          try {
            const value = error[key];
            if (typeof value === "function") {
              clean_object[key] = "[Function]";
            } else if (typeof value === "object" && value !== null) {
              if (seen.has(value)) {
                clean_object[key] = "[Circular Reference]";
              } else {
                seen.add(value);
                try {
                  clean_object[key] = JSON.parse(JSON.stringify(value));
                } catch (e) {
                  clean_object[key] = "[Non-serializable Object]";
                }
              }
            } else {
              clean_object[key] = value;
            }
          } catch (e) {
            clean_object[key] = "[Inaccessible Property]";
          }
        }
        error_obj.data = clean_object;
      }
    }
  } catch (processing_error) {
    return {
      type: "ProcessingError",
      message: "Failed to process error object",
      original_error: String(error),
      processing_error: processing_error.message,
      timestamp: new Date().toISOString(),
    };
  }

  return error_obj;
}
